import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

import { transportTypeOptions } from './transportTypeOptions';

/**
 * The space types to offer on the trip form. A null, missing or empty org
 * selection offers all of them. The trip's current value stays listed even
 * when it isn't offered, so editing an older trip doesn't blank its space type.
 */
export function allowedSpaceTypeOptions(
  allowed: readonly string[] | null | undefined,
  current?: string | null
): SelectOption[] {
  if (!allowed?.length) return transportTypeOptions;
  return transportTypeOptions.filter(
    (option) => allowed.includes(option.value) || option.value === current
  );
}
